/* ============================================================
   LP専用 JavaScript：ワイヤレスフットコントローラー MKF-1000
   配置場所: assets/lp-mkf1000.js
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  /* ======================
     ハンバーガーメニュー
  ====================== */
  var hamburger = document.getElementById('lpHamburger');
  var nav       = document.getElementById('lpNav');

  var overlay = document.createElement('div');
  overlay.style.cssText = 'display:none;position:fixed;inset:0;background:rgba(0,0,0,0.4);z-index:89;';
  document.body.appendChild(overlay);

  function openMenu() {
    hamburger.classList.add('is-open');
    nav.classList.add('is-open');
    overlay.style.display = 'block';
    document.body.classList.add('menu-open');
  }

  function closeMenu() {
    hamburger.classList.remove('is-open');
    nav.classList.remove('is-open');
    overlay.style.display = 'none';
    document.body.classList.remove('menu-open');
  }

  if (hamburger) {
    hamburger.addEventListener('click', function () {
      hamburger.classList.contains('is-open') ? closeMenu() : openMenu();
    });
  }

  overlay.addEventListener('click', closeMenu);

  var navLinks = nav ? nav.querySelectorAll('a') : [];
  navLinks.forEach(function (link) {
    link.addEventListener('click', closeMenu);
  });


  /* ======================
     Meta Pixel ユーティリティ
  ====================== */
  function firePixel(leadParams, customName, customParams) {
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      if (typeof fbq === 'function') {
        clearInterval(timer);
        fbq('track', 'Lead', leadParams || {});
        if (customName) {
          fbq('trackCustom', customName, customParams || {});
        }
      }
      if (tries >= 10) clearInterval(timer);
    }, 50);
  }

  function oncePerClick(handler) {
    return function (e) {
      if (this.dataset.fbqFired === '1') return;
      this.dataset.fbqFired = '1';
      var self = this;
      setTimeout(function () { self.dataset.fbqFired = ''; }, 500);
      handler.call(this, e);
    };
  }


  /* ======================
     TEL ボタン（遷移を止めない）
  ====================== */
  var telBtn = document.getElementById('tel-btn');
  if (telBtn) {
    telBtn.addEventListener('click', oncePerClick(function () {
      firePixel({ method: 'tel' }, 'TelClick', { method: 'tel' });
      /* tel: リンクはブラウザ標準動作で発信アプリが開くため
         preventDefaultしない（遷移を止めない） */
    }));
  }


  /* ======================
     固定CTAボタン（購入ページへ・200ms遅延でPixel発火を待つ）
  ====================== */
  var lineFixedBtn = document.getElementById('line-fixed-btn');
  if (lineFixedBtn) {
    lineFixedBtn.addEventListener('click', oncePerClick(function (e) {
      e.preventDefault();
      var url = this.href;
      firePixel(
        { method: 'purchase_button', position: 'fixed' },
        'PurchaseClick',
        { position: 'fixed' }
      );
      setTimeout(function () { window.location.href = url; }, 200);
    }));
  }


  /* ======================
     購入CTAボタン（旧Makuakeボタン・購入ページへ変更済み）
  ====================== */
  var lineContactBtn = document.getElementById('line-contact-btn');
  if (lineContactBtn) {
    lineContactBtn.addEventListener('click', oncePerClick(function (e) {
      e.preventDefault();
      var url = this.href;
      firePixel(
        { method: 'purchase_button', position: 'contact' },
        'PurchaseClick',
        { position: 'contact' }
      );
      setTimeout(function () { window.location.href = url; }, 200);
    }));
  }


  /* ======================
     スムーズスクロール
  ====================== */
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      var targetId = this.getAttribute('href').slice(1);
      if (!targetId) return;
      var target = document.getElementById(targetId);
      if (!target) return;
      e.preventDefault();
      var headerHeight = document.querySelector('.lp-header')
        ? document.querySelector('.lp-header').offsetHeight
        : 60;
      var targetTop = target.getBoundingClientRect().top + window.pageYOffset - headerHeight - 8;
      window.scrollTo({ top: targetTop, behavior: 'smooth' });
    });
  });

});